import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { PeriodEnum, translateKey } from "common/enums/PeriodEnum";
import { Form, Page } from "@cc/react-components";
import PrescriptionPeriodPickerPopOver from "components/Picker/PrescriptionPeriodPickerPopOver";

interface Props extends React.HTMLAttributes<HTMLElement> {
  selectionPeriod: { number: number; unit: PeriodEnum };
  setSelectionPeriod?: (selectionPeriod: {
    number: number;
    unit: PeriodEnum;
  }) => void;
}

const MedicationPeriod = ({ selectionPeriod, setSelectionPeriod }: Props) => {
  const [t] = useTranslation();
  const [pickerOpen, setPickerOpen] = useState(false);
  const onHandleChange = (name: string, value: any) => {
    !!setSelectionPeriod &&
      setSelectionPeriod(
        Object.assign({}, selectionPeriod, {
          [name]: value,
        })
      );
  };

  return (
    <>
      <Page>
        <Page.Body onClick={() => setPickerOpen(!pickerOpen)}>
          <Page.Title className="font-weight-bold">
            {t("medicationFlow.period")}
          </Page.Title>
          <Form>
            <Form.Input
              disabled
              className="text-center p-2"
              value={
                selectionPeriod.number +
                " " +
                t(translateKey(selectionPeriod.unit))
              }
              onClick={() => setPickerOpen(!pickerOpen)}
            />
          </Form>
        </Page.Body>
      </Page>
      <PrescriptionPeriodPickerPopOver
        selection={selectionPeriod}
        pickerOpen={pickerOpen}
        setPickerOpen={setPickerOpen}
        handleChange={onHandleChange}
      />
    </>
  );
};

export default MedicationPeriod;
